













































import { Component, Prop, Vue } from "vue-property-decorator";
import { ButtonVariant, CREATE_PARTY_CONSTRAINTS, Party } from "@/types";

@Component
export default class CreatePartyForm extends Vue {
  $refs!: {
    form: HTMLFormElement;
  };

  $enums = {
    ButtonVariant
  };

  @Prop({ required: true }) party!: Party;
  acceptedTerms = false;

  constraints = CREATE_PARTY_CONSTRAINTS;

  onSubmit(event: Event): void {
    event.preventDefault();

    const form = this.$refs.form;
    if (form.checkValidity()) {
      this.$emit("submit", this.party);
    }
  }
}
